
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { PqtApiUiV2Client, PqtProduct, PqtProductTest } from '../../backend/backendapi';
import PqtEdit from './PqtEdit';
import State from '../State';
import { handleError, initClient } from '../../../api';
import { blobDownload } from '../../../util';
import Spinner from '../../util/Spinner';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    PqtEdit,
    Spinner,
  },
})
export default class PqtEditModal extends Vue {
  @Prop({ default: true })
  readonly editable!: boolean;
  @Prop({ default: true })
  readonly showArchiveFields!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  private readonly api = initClient(PqtApiUiV2Client);

  product: PqtProduct | null = null;
  tests: PqtProductTest[] | null = null;

  printing = false;

  get canSave(): boolean {
    return !!this.product
        && (!this.state.config.requiredFields?.includes('product.group') || this.product.groupId > 0)
        && (!this.state.config.requiredFields?.includes('product.ident') || !!this.product.ident)
        && (!this.state.config.requiredFields?.includes('product.name') || !!this.product.name)
        && (!this.state.config.requiredFields?.includes('product.entryDate') || !!this.product.entryDate)
        && (!this.state.config.requiredFields?.includes('product.issueDate') || !!this.product.issueDate)
        && (!this.state.config.requiredFields?.includes('product.status') || !!this.product.status)
        && (!this.state.config.requiredFields?.includes('product.responsible') || !!this.product.responsible)
        && (!this.state.config.requiredFields?.includes('product.warningMail') || !!this.product.warningMail)
        && (!this.state.config.requiredFields?.includes('product.testSpecification') || !!this.product.testSpecification)
        && (!this.state.config.requiredFields?.includes('product.errorMargin') || !!this.product.errorMargin)
        && (!this.state.config.requiredFields?.includes('product.testProcedure') || !!this.product.testProcedure)
        && (!this.state.config.requiredFields?.includes('product.costCenter') || !!this.product.costCenter)
        && (!this.state.config.requiredFields?.includes('product.note') || !!this.product.note)
        && (!this.state.config.requiredFields?.includes('product.revision') || !!this.product.revision)
        && (!this.state.config.requiredFields?.includes('product.customString1') || !!this.product.customString1)
        && (!this.state.config.requiredFields?.includes('product.customString2') || !!this.product.customString2)
        && (!this.state.config.requiredFields?.includes('product.customString3') || !!this.product.customString3);
  }

  public open(product: PqtProduct, tests: PqtProductTest[] | null): void {
    this.product = product;
    this.tests = tests;
    this.autoFillHiddenRequiredFields();
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.product = null;
    this.tests = null;
    $(this.$refs.modal!).modal('hide');
  }

  autoFillHiddenRequiredFields(): void {
    if (!this.product) {
      return;
    }

    const isHiddenRequired = (key: string) => this.state.config.hiddenFields?.includes(key)
        && this.state.config.requiredFields?.includes(key);

    if (isHiddenRequired('product.group')) this.product.groupId ||= this.state.groupsStore.groupTypes[0]?.id;
    if (isHiddenRequired('product.ident')) this.product.ident ||= 'n/a';
    if (isHiddenRequired('product.name')) this.product.name ||= 'n/a';
    if (isHiddenRequired('product.entryDate')) this.product.entryDate ||= new Date();
    if (isHiddenRequired('product.issueDate')) this.product.issueDate ||= new Date();
    if (isHiddenRequired('product.status')) this.product.status ||= 'n/a';
    if (isHiddenRequired('product.responsible')) this.product.responsible = 'n/a';
    if (isHiddenRequired('product.warningMail')) this.product.warningMail ||= 'none@example.com';
    if (isHiddenRequired('product.testSpecification')) this.product.testSpecification = 'n/a';
    if (isHiddenRequired('product.errorMargin')) this.product.errorMargin = 'n/a';
    if (isHiddenRequired('product.testProcedure')) this.product.testProcedure = 'n/a';
    if (isHiddenRequired('product.costCenter')) this.product.costCenter = 'n/a';
    if (isHiddenRequired('product.note')) this.product.note = 'n/a';
    if (isHiddenRequired('product.revision')) this.product.revision = 'n/a';
    if (isHiddenRequired('product.customString1')) this.product.customString1 = 'n/a';
    if (isHiddenRequired('product.customString2')) this.product.customString2 = 'n/a';
    if (isHiddenRequired('product.customString3')) this.product.customString3 = 'n/a';
  }

  async printProduct(): Promise<void> {
    if (!this.product) {
      return;
    }

    this.printing = true;
    try {
      const res = await this.api.productAsPdf(this.product.id);
      blobDownload(res.data, res.fileName!);
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.printing = false;
    }
  }

  save(): void {
    this.$emit('save', this.product);
  }
}
